module.exports = __webpack_public_path__ + "img/banner.aeb96218.png";